import { PERMISSIONS } from '../constants/permissions';
import type { VisitorModuleCapabilities } from '../types/visitor';
import { hasPermission } from '../utils/permissions';

/**
 * Visitor module capabilities from mounted arkhrmsapi visitor.routes.js.
 *
 * Mounted:
 * - GET /visitors, GET /visitors/visits (VISITOR_VIEW)
 * - POST /visitors, POST /visitors/check-in, POST /visitors/check-out,
 *   DELETE /visitors/:visitorId (VISITOR_MANAGE)
 *
 * Which roles hold these codes (HR Admin, Team Lead, Reporting Manager) is
 * decided by the database role grants, not by this file.
 */
export function getVisitorModuleCapabilities(
  permissions: readonly string[],
): VisitorModuleCapabilities {
  return {
    canViewVisitors: hasPermission(permissions, PERMISSIONS.VISITOR_VIEW),
    canManageVisitors: hasPermission(permissions, PERMISSIONS.VISITOR_MANAGE),
  };
}
